import React, { Fragment } from "react";

import { Skeleton, } from "@mui/material";
import { isDev, ImageURL } from '../../../../Global'

const Detail = ({ Data, isLoading }) => {
  const JobdeskDocument = Data ? Data.JobdeskDocument : null

  const DefaultUrl = ImageURL.Base

  const isInDev = isDev()
  if (isInDev) {
    console.log(JobdeskDocument ? `JobdeskDocument: ${DefaultUrl}/${JobdeskDocument}` : '')
  }
  return (
    <Fragment>
      {isLoading ? (
        <Fragment>
          {[1, 2, 3, 4, 5, 6, 7].map((item) => (
            <Skeleton height={"8vh"} key={`PRForm_Skeleton_${item}`} />
          ))}
        </Fragment>
      ) : (
        <Fragment>
          <h3>Job Description Detail</h3>
          <div
            style={{
              margin: "1% 0 1% 0",
              padding: "1%",
              border: `1px solid Green`,
            }}
          >
            <h4>
              Created by:
              <br />
              {Data?.BiodataNama ? Data.BiodataNama : ""}
              <br />
              <br />
              {/* {Data?.AccBioNama ? Data.AccBioNama : ''}<br /><br /> */}
              On:
              <br />
              {Data?.TanggalPengajuan
                ? new Date(Data.TanggalPengajuan).toLocaleString(["ban", "id"])
                : ""}
              <br />
            </h4>
          </div>

          <h3>File: </h3>
          <center>
            <div>
              {JobdeskDocument ?
                <center>
                  <iframe
                    src={`${DefaultUrl}/${JobdeskDocument}`}
                    // height="1000"
                    // width="1000"
                    title='Curriculum Vitae'
                    style={{ width: '60vw', minHeight: '100vh' }}
                  />
                </center>
                : <Fragment>
                  <center>
                    <h1>
                      No Data
                    </h1>
                  </center>
                </Fragment>
              }
            </div>
          </center>
        </Fragment>
      )}
    </Fragment>
  );
};
export default Detail;
